import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function HomepageHero() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/media/homepage_hero").then(r => setItems(r.data || [])).catch(()=>{});
  }, []);

  if (!items.length) return null;
  const cur = items[idx] || items[0];

  const go = (delta) => {
    setIdx((idx + delta + items.length) % items.length);
  };

  const handleClick = () => {
    if (cur.link) {
      if (cur.link.startsWith("/")) navigate(cur.link);
      else window.open(cur.link, "_blank");
    }
  };

  return (
    <div className="lt-hero" data-testid="homepage-hero">
      <div className="lt-hero-stage">
        {items.map((m, i) => (
          <div key={m.id || i}
               className={`lt-hero-slide ${i===idx?"on":""}`}
               style={{ backgroundImage: `url("${m.image_url}")` }}
               aria-hidden={i!==idx}/>
        ))}
        <div className="lt-hero-shade" />
        <div className="lt-hero-grain" />
        <div className="lt-hero-content">
          <div className="lt-hero-eyebrow">LANTEN ·  REAL RENTAL STORIES</div>
          <h1 className="lt-hero-title">{cur.title}</h1>
          <div className="lt-hero-sub">{cur.subtitle}</div>
          <button className="lt-hero-cta" data-testid="hero-cta" onClick={handleClick}>
            Read stories <span style={{marginLeft:6,fontSize:12}}>→</span>
          </button>
        </div>
        {items.length > 1 && (
          <>
            <button className="lt-hero-nav prev" data-testid="hero-prev" onClick={()=>go(-1)} aria-label="Previous">‹</button>
            <button className="lt-hero-nav next" data-testid="hero-next" onClick={()=>go(1)} aria-label="Next">›</button>
            <div className="lt-hero-dots">
              {items.map((_, i) => (
                <button key={i} className={`lt-hero-dot ${i===idx?"on":""}`} onClick={()=>setIdx(i)} aria-label={`Slide ${i+1}`} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
